import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { PLANS, PLANS_NAME } from '@static/config';

export interface ICurrentPolicyFlow {
  policy: string,
  isRevampedLayout: boolean
}

export interface LoadingState {
  CurrentPolicyFlow: ICurrentPolicyFlow;
  isShowing: boolean;
  isShowAddMyInfo: boolean;
  isFastPaymenInProgress: boolean,
  productInitiatedFastPayment: string, 
  isEnableSIO: boolean;
  campaignEligibility: boolean;
  isGIOEligible?: boolean;
  isCSTopupEligible?: boolean;
  campaignDetail: any;
  isGlobalError: boolean;
  errorContent: [string, string];
  isMaintenance: boolean;
  isMaintenanceMessageShowing: boolean;
  maintenanceMessage: string;
  isTokenRecieved: boolean;
  isInvalidArcCodeFromUrl: boolean;
  arcCodeRecieved: Record<string, {isValid:boolean, arcCode:string}> | null
}

const initialState: LoadingState = {
  CurrentPolicyFlow: {
    policy: "",
    isRevampedLayout: false,
  },
  isShowing: false,
  isShowAddMyInfo: false,
  isEnableSIO: false,
  campaignEligibility: false,
  isGIOEligible: false,
  isCSTopupEligible: false,
  isFastPaymenInProgress: false,
  productInitiatedFastPayment: "",
  campaignDetail: null,
  isGlobalError: false,
  errorContent: ["", ""],
  isMaintenance: false,
  isTokenRecieved: false,
  isMaintenanceMessageShowing: false,
  isInvalidArcCodeFromUrl: false,
  maintenanceMessage:
    "Kindly note that we will be experiencing server downtime due to scheduled maintenance today (8th June, 06:00:00). Apologies for any inconvenience that this may cause.",
  arcCodeRecieved: null,
};

const loadingSlice = createSlice({
  name: "GLOBAL-Loading",
  initialState,
  reducers: {
    setIsTokenRecieved: (state, action: PayloadAction<boolean>) => {
      state.isTokenRecieved = action.payload;
    },
    setCurrentPolicyFlow: (
      state,
      action: PayloadAction<ICurrentPolicyFlow>,
    ) => {
      state.CurrentPolicyFlow = action.payload;
    },
    setLoadingState: (state, action: PayloadAction<boolean>) => {
      state.isShowing = action.payload;
    },
    setShowAddInfo: (state, action: PayloadAction<boolean>) => {
      state.isShowAddMyInfo = action.payload;
    },
    setEnableSIO: (state, action: PayloadAction<boolean>) => {
      state.isEnableSIO = action.payload;
    },
    setCampaignEligibilityFlags: (
      state,
      action: PayloadAction<{
        campaignEligibility: boolean;
        isGIOEligible: boolean;
        isCSTopupEligible: boolean;
      }>,
    ) => {
      state.campaignEligibility = action.payload.campaignEligibility;
      state.isGIOEligible = action.payload.isGIOEligible;
      state.isCSTopupEligible = action.payload.isCSTopupEligible;
    },
    setCampaignDetail: (state, action: PayloadAction<any>) => {
      state.campaignDetail = action.payload;
    },
    setIsGlobalError: (state, action: PayloadAction<boolean>) => {
      state.isGlobalError = action.payload;
    },
    setErrorContent: (state, action: PayloadAction<[string, string]>) => {
      state.errorContent = action.payload;
    },
    setMaintenance: (state, action: PayloadAction<boolean>) => {
      state.isMaintenance = action.payload;
    },
    setMaintenanceMessageShowing: (state, action: PayloadAction<boolean>) => {
      state.isMaintenanceMessageShowing = action.payload;
    },
    setMaintenanceMessage: (state, action: PayloadAction<string>) => {
      state.maintenanceMessage = action.payload;
    },
    setInvalidArcCodeFromUrl: (state, action: PayloadAction<boolean>) => {
      state.isInvalidArcCodeFromUrl = action.payload;
    },
    setFastPaymentInProgrees: (
      state,
      action: PayloadAction<{
        isFastPaymenInProgress?: boolean;
        productInitiatedFastPayment?: string;
      }>,
    ) => ({
      ...state,
      ...action.payload,
    }),
    updateCurrentProductArcStatus: (
      state,
      action: PayloadAction<{
        PLAN_NAME: PLANS_NAME;
        values: { isValid: boolean; arcCode: string };
      }>,
    ) => {
      state.arcCodeRecieved = {
        ...state.arcCodeRecieved,
        [PLANS[action.payload.PLAN_NAME as unknown as string]]:
          action.payload.values,
      };
    },
  },
  extraReducers: {},
});

export const {setIsTokenRecieved, setCurrentPolicyFlow, setLoadingState, setShowAddInfo, setEnableSIO, setCampaignEligibilityFlags, setCampaignDetail, setIsGlobalError, setErrorContent,setMaintenance, setMaintenanceMessageShowing, setMaintenanceMessage, setInvalidArcCodeFromUrl, setFastPaymentInProgrees, updateCurrentProductArcStatus} = loadingSlice.actions;

export default loadingSlice.reducer;